webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(156);
	
	var _vue = __webpack_require__(92);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(389);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(372);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _TopPage = __webpack_require__(129);
	
	var _TopPage2 = _interopRequireDefault(_TopPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var routes = [{ path: '', component: _TopPage2.default }];
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: routes
	});
	
	new _vue2.default({
	  render: function render(h) {
	    return h(_App2.default);
	  },
	
	  router: router
	}).$mount('#app');

/***/ },

/***/ 64:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = 'http://oyakohug.com/';

/***/ },

/***/ 129:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(345)
	__webpack_require__(346)
	
	var Component = __webpack_require__(30)(
	  /* script */
	  __webpack_require__(155),
	  /* template */
	  __webpack_require__(385),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 147:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TopPage = __webpack_require__(129);
	
	var _TopPage2 = _interopRequireDefault(_TopPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    TopPage: _TopPage2.default
	  }
	};

/***/ },

/***/ 148:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(92);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(93);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vueAxios = __webpack_require__(128);
	
	var _vueAxios2 = _interopRequireDefault(_vueAxios);
	
	var _jquery = __webpack_require__(43);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(91);
	
	var _Post = __webpack_require__(378);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	var _wp_url = __webpack_require__(64);
	
	var _wp_url2 = _interopRequireDefault(_wp_url);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootURL = _wp_url2.default;
	var postsURL = _wp_url2.default + 'wp-json/wp/v2/posts?_embed&per_page=5';
	
	_vue2.default.use(_vueAxios2.default, _axios2.default);
	
	exports.default = {
	  name: 'BlogSlide',
	  components: {
	    Post: _Post2.default
	  },
	
	  created: function created() {
	    this.getPosts();
	  },
	  data: function data() {
	    return {
	      posts: [],
	      home_url: rootURL
	    };
	  },
	
	
	  methods: {
	    getPosts: function getPosts() {
	      var _this = this;
	
	      _vue2.default.axios.get(postsURL).then(function (response) {
	        _this.posts = response.data;
	        var self = _this;
	        self.initSlick();
	      });
	    },
	    initSlick: function initSlick() {
	      (0, _jquery2.default)(function PostSlider() {
	        (0, _jquery2.default)('.PostSlider').slick({
	          slidesToShow: 1,
	          slidesToScroll: 1,
	          arrows: false,
	          dots: true,
	          mobileFirst: true,
	          responsive: [{
	            breakpoint: 767,
	            settings: {
	              slidesToShow: 3,
	              centerMode: false
	            }
	          }, {
	            breakpoint: 1023,
	            settings: 'unslick'
	          }]
	        });
	      });
	    }
	  }
	};

/***/ },

/***/ 149:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(43);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ClubSlide',
	
	  created: function created() {
	    this.initSlick();
	  },
	
	
	  methods: {
	    initSlick: function initSlick() {
	      (0, _jquery2.default)(function () {
	        (0, _jquery2.default)('.footerContent ul').slick({
	          slidesToShow: 1,
	          slidesToScroll: 1,
	          centerMode: true,
	          centerPadding: '15px',
	          arrows: false,
	          dots: true,
	          mobileFirst: true,
	          responsive: [{
	            breakpoint: 767,
	            settings: {
	              slidesToShow: 2,
	              centerMode: false
	            }
	          }, {
	            breakpoint: 1023,
	            settings: 'unslick'
	          }]
	        });
	      });
	    }
	  }
	};

/***/ },

/***/ 150:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(92);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(93);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vueAxios = __webpack_require__(128);
	
	var _vueAxios2 = _interopRequireDefault(_vueAxios);
	
	var _jquery = __webpack_require__(43);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(91);
	
	var _wp_url = __webpack_require__(64);
	
	var _wp_url2 = _interopRequireDefault(_wp_url);
	
	var _NewsList = __webpack_require__(377);
	
	var _NewsList2 = _interopRequireDefault(_NewsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootURL = _wp_url2.default;
	var postsURL = _wp_url2.default + 'wp-json/wp/v2/posts?_embed&per_page=5';
	
	_vue2.default.use(_vueAxios2.default, _axios2.default);
	
	exports.default = {
	  name: 'HeaderSlide',
	  components: {
	    NewsList: _NewsList2.default
	  },
	
	  created: function created() {
	    this.getPosts();
	  },
	  data: function data() {
	    return {
	      posts: [],
	      home_url: rootURL
	    };
	  },
	
	
	  methods: {
	    getPosts: function getPosts() {
	      var _this = this;
	
	      _vue2.default.axios.get(postsURL).then(function (response) {
	        _this.posts = response.data;
	        var self = _this;
	        self.initSlick();
	      });
	    },
	    initSlick: function initSlick() {
	      (0, _jquery2.default)(function PostSlider() {
	        (0, _jquery2.default)('.NewsSlider').slick({
	          slidesToShow: 1,
	          slidesToScroll: 1,
	          arrows: false,
	          vertical: true,
	          autoplay: true
	        });
	      });
	    }
	  }
	};

/***/ },

/***/ 151:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'IdeaSlide'
	};

/***/ },

/***/ 152:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'NewsList',
	  props: {
	    post: {
	      type: Object,
	      default: function _default() {
	        return {
	          date: '',
	          link: '',
	          title: { rendered: '' }
	        };
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    if (!this.post.id) {
	      this.getPost();
	      this.isSingle = true;
	    }
	  },
	
	
	  computed: {
	    date: function date() {
	      var date = new Date(this.post.date);
	      var y = date.getFullYear();
	      var m = date.getMonth() + 1;
	      var d = date.getDate();
	      return y + '.' + m + '.' + d;
	    }
	  }
	};

/***/ },

/***/ 153:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _wp_url = __webpack_require__(64);
	
	var _wp_url2 = _interopRequireDefault(_wp_url);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postURL = _wp_url2.default + 'wp-json/wp/v2/posts?_embed';
	
	exports.default = {
	  name: 'Post',
	  props: {
	    post: {
	      type: Object,
	      default: function _default() {
	        return {
	          id: 0,
	          slug: '',
	          date: '',
	          link: '',
	          title: { rendered: '' },
	          content: { rendered: '' },
	          _embedded: ''
	        };
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    if (!this.post.id) {
	      this.getPost();
	      this.isSingle = true;
	    }
	  },
	  data: function data() {
	    return {
	      base_path: postURL,
	      isSingle: false
	    };
	  },
	
	  computed: {
	    getThumbnail: function getThumbnail() {
	      if (this.post.featured_media !== 0) {
	        var thumbnailHtml = this.post._embedded['wp:featuredmedia'][0].media_details.sizes.thumbnail.source_url;
	        return thumbnailHtml;
	      }
	      var initThumbnail = '../assets/images/common/thumbnail.png';
	      return initThumbnail;
	    },
	    date: function date() {
	      var date = new Date(this.post.date);
	      var y = date.getFullYear();
	      var m = date.getMonth() + 1;
	      var d = date.getDate();
	      return y + '.' + m + '.' + d;
	    }
	  }
	};

/***/ },

/***/ 154:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'IdeaSlide'
	};

/***/ },

/***/ 155:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gsap = __webpack_require__(354);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	var _jquery = __webpack_require__(43);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(353);
	
	__webpack_require__(355);
	
	var _HeaderSlide = __webpack_require__(375);
	
	var _HeaderSlide2 = _interopRequireDefault(_HeaderSlide);
	
	var _IdeaSlide = __webpack_require__(376);
	
	var _IdeaSlide2 = _interopRequireDefault(_IdeaSlide);
	
	var _ClubSlide = __webpack_require__(374);
	
	var _ClubSlide2 = _interopRequireDefault(_ClubSlide);
	
	var _SupportSlide = __webpack_require__(379);
	
	var _SupportSlide2 = _interopRequireDefault(_SupportSlide);
	
	var _BlogSlide = __webpack_require__(373);
	
	var _BlogSlide2 = _interopRequireDefault(_BlogSlide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TopPage',
	  components: {
	    HeaderSlide: _HeaderSlide2.default,
	    IdeaSlide: _IdeaSlide2.default,
	    ClubSlide: _ClubSlide2.default,
	    SupportSlide: _SupportSlide2.default,
	    BlogSlide: _BlogSlide2.default
	  },
	
	  mounted: function mounted() {
	    this.fullPage();
	  },
	
	
	  methods: {
	    fullPage: function fullPage() {
	      (0, _jquery2.default)(function () {
	        if ((0, _jquery2.default)('body').width() >= 1024) {
	          _gsap2.default.set('.section', {
	            transformPerspective: 600,
	            rotationX: '-60',
	            transformOrigin: 'center top',
	            opacity: 0
	          });
	          (0, _jquery2.default)('#fullpage').fullpage({
	            sectionSelector: '.start, .section',
	            responsiveWidth: 1024,
	            navigation: true,
	            navigationPosition: 'right',
	            navigationTooltips: ['おやこハグネット', '理念', '放課後児童クラブ', '児童家庭支援事業', 'おやこハグ日記'],
	
	            onLeave: function onLeave(index, nextIndex, direction) {
	              var beforeSlides = (0, _jquery2.default)(this).prevAll();
	              if (direction === 'up') {
	                _gsap2.default.to(beforeSlides, 0.5, {
	                  rotationX: 0,
	                  opacity: 1
	                });
	                _gsap2.default.to(this, 0.5, {
	                  transformPerspective: 600,
	                  rotationX: '-60',
	                  opacity: 0,
	                  delay: 0.5
	                });
	              }
	            },
	
	            afterLoad: function afterLoad(anchorLink, index) {
	              var afterSlides = (0, _jquery2.default)(this).nextAll();
	              _gsap2.default.to(this, 0.5, {
	                rotationX: 0,
	                opacity: 1
	              });
	              _gsap2.default.to(afterSlides, 0.5, {
	                transformPerspective: 600,
	                rotationX: '-60',
	                opacity: 0
	              });
	            }
	          });
	        }
	      });
	    }
	  }
	};

/***/ },

/***/ 338:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 339:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 340:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 341:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 342:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 343:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 344:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 345:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 346:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 347:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 348:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 349:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 350:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 351:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 352:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 357:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo.9704cdf.svg";

/***/ },

/***/ 358:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img_blog-header.b15b3ce.svg";

/***/ },

/***/ 359:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img_club-header.ff15d2b.svg";

/***/ },

/***/ 360:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img_club.c0c9de5.png";

/***/ },

/***/ 361:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img_clubfooter001.f93b029.png";

/***/ },

/***/ 362:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img_clubfooter002.663c530.png";

/***/ },

/***/ 363:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img_clubfooter003.2f0508c.png";

/***/ },

/***/ 364:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img_clubfooter004.f50397e.png";

/***/ },

/***/ 365:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img_idea-header.c0411db.svg";

/***/ },

/***/ 366:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img_idea.ce61e12.png";

/***/ },

/***/ 367:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img_support-header.44b53bf.svg";

/***/ },

/***/ 368:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img_support.3f85038.png";

/***/ },

/***/ 369:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img_supportlist001.8cd2ff4.jpg";

/***/ },

/***/ 370:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img_supportlist002.5f1d233.jpg";

/***/ },

/***/ 371:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/img_supportlist003.a194010.jpg";

/***/ },

/***/ 372:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(347)
	__webpack_require__(348)
	
	var Component = __webpack_require__(30)(
	  /* script */
	  __webpack_require__(147),
	  /* template */
	  __webpack_require__(386),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 373:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(339)
	__webpack_require__(338)
	__webpack_require__(340)
	
	var Component = __webpack_require__(30)(
	  /* script */
	  __webpack_require__(148),
	  /* template */
	  __webpack_require__(380),
	  /* scopeId */
	  "data-v-33e2af88",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 374:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(351)
	__webpack_require__(350)
	__webpack_require__(352)
	
	var Component = __webpack_require__(30)(
	  /* script */
	  __webpack_require__(149),
	  /* template */
	  __webpack_require__(388),
	  /* scopeId */
	  "data-v-e702acb0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 375:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(342)
	
	var Component = __webpack_require__(30)(
	  /* script */
	  __webpack_require__(150),
	  /* template */
	  __webpack_require__(382),
	  /* scopeId */
	  "data-v-4a7e6471",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 376:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(349)
	
	var Component = __webpack_require__(30)(
	  /* script */
	  __webpack_require__(151),
	  /* template */
	  __webpack_require__(387),
	  /* scopeId */
	  "data-v-b921eef2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 377:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(344)
	
	var Component = __webpack_require__(30)(
	  /* script */
	  __webpack_require__(152),
	  /* template */
	  __webpack_require__(384),
	  /* scopeId */
	  "data-v-59b42b94",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 378:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(341)
	
	var Component = __webpack_require__(30)(
	  /* script */
	  __webpack_require__(153),
	  /* template */
	  __webpack_require__(381),
	  /* scopeId */
	  "data-v-3e474423",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 379:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(343)
	
	var Component = __webpack_require__(30)(
	  /* script */
	  __webpack_require__(154),
	  /* template */
	  __webpack_require__(383),
	  /* scopeId */
	  "data-v-4f79d6a5",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 380:
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "section"
	  }, [_c('div', {
	    staticClass: "Slide"
	  }, [_c('article', [_vm._m(0), _vm._v(" "), _c('ul', {
	    staticClass: "PostSlider"
	  }, _vm._l((_vm.posts), function(post) {
	    return _c('li', [_c('post', {
	      attrs: {
	        "post": post
	      }
	    })], 1)
	  })), _vm._v(" "), _c('a', {
	    staticClass: "toBlog",
	    attrs: {
	      "href": _vm.home_url + 'blog/'
	    }
	  }, [_vm._v("≫ ブログ一覧を見る")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(358),
	      "alt": "おやこハグ日記"
	    }
	  })]), _vm._v(" "), _c('h2', [_vm._v("おやこハグネットは、"), _c('br', {
	    staticClass: "visible-sp"
	  }), _vm._v("日々様々な活動を行っています。")])])
	}]}

/***/ },

/***/ 381:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "Post"
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.post.link
	    }
	  }, [_c('div', {
	    staticClass: "Thumbnail"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.getThumbnail,
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "Text"
	  }, [_c('p', [_vm._v(_vm._s(_vm.date))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.post.title.rendered))])])])])
	},staticRenderFns: []}

/***/ },

/***/ 382:
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "start"
	  }, [_c('div', {
	    staticClass: "Slide"
	  }, [_c('header', [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "NewsWrapper"
	  }, [_c('div', {
	    staticClass: "News"
	  }, [_c('p', [_vm._v("更新情報")]), _vm._v(" "), _c('ul', {
	    staticClass: "NewsSlider"
	  }, _vm._l((_vm.posts), function(post) {
	    return _c('news-list', {
	      attrs: {
	        "post": post
	      }
	    })
	  }))]), _vm._v(" "), _c('p', {
	    staticClass: "ToBlog"
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.home_url + 'blog/'
	    }
	  }, [_vm._v("≫ ブログ一覧を見る")])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(357),
	      "alt": "おやこハグネット"
	    }
	  })])
	}]}

/***/ },

/***/ 383:
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "section"
	  }, [_c('div', {
	    staticClass: "Slide"
	  }, [_c('section', [_c('header', [_c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(367),
	      "alt": "児童家庭支援事業"
	    }
	  })]), _vm._v(" "), _c('h2', [_vm._v("様々な環境で暮らす子どもたちを、"), _c('br', {
	    staticClass: "visible-sm"
	  }), _vm._v("地域の関係機関が"), _c('br'), _vm._v("繋がりながら支援しています。")])]), _vm._v(" "), _c('div', {
	    staticClass: "image"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(368),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(369),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v("まちこや")]), _vm._v(" "), _c('p', [_vm._v("開催場所：山代老人児童センター内"), _c('br'), _vm._v("開催日時：第1・第3土曜日 午前10時30分～11時30分読み書き・そろばんの基本的なことや、大学生や中学生が、理科の実験や外国語などを通じて、知ることはワクワクドキドキ！を教えてくれます。")])]), _vm._v(" "), _c('li', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(370),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v("よりみちハウス")]), _vm._v(" "), _c('p', [_vm._v("開催場所：石川県加賀市山代温泉山背台　寄り道ハウス内"), _c('br'), _vm._v("\n          開催日時：学校課業日　月・水・金　午後3時～5時"), _c('br'), _vm._v("\n          子どもたちが学校の帰り、宿題をしながら、町のおじちゃん、おばちゃんが話し相手になってくれます。")])]), _vm._v(" "), _c('li', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(371),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v("山代の子どもを育てる会")]), _vm._v(" "), _c('p', [_vm._v("開催場所：石川県加賀市山代温泉北部1-233"), _c('br'), _vm._v("\n            開催日時：毎月第4月曜日　午後1時30分"), _c('br'), _vm._v("\n            子どもたちを取り巻く様々な機関が一堂に集まり、子どもたちの現状について情報交換をし、ゆるく繋がることで、情報の共有をします。")])])])])])])
	}]}

/***/ },

/***/ 384:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_vm._v(_vm._s(_vm.date) + "："), _c('a', {
	    attrs: {
	      "href": _vm.post.link
	    }
	  }, [_vm._v(_vm._s(_vm.post.title.rendered))])])
	},staticRenderFns: []}

/***/ },

/***/ 385:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    attrs: {
	      "id": "fullpage"
	    }
	  }, [_c('header-slide'), _vm._v(" "), _c('idea-slide'), _vm._v(" "), _c('club-slide'), _vm._v(" "), _c('support-slide'), _vm._v(" "), _c('blog-slide')], 1)
	},staticRenderFns: []}

/***/ },

/***/ 386:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('TopPage')], 1)
	},staticRenderFns: []}

/***/ },

/***/ 387:
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "section"
	  }, [_c('div', {
	    staticClass: "Slide"
	  }, [_c('section', [_c('header', [_c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(365),
	      "alt": "理念"
	    }
	  })]), _vm._v(" "), _c('h2', [_vm._v("平成２２年３月に、児童の心身ともに"), _c('br', {
	    staticClass: "visible-sm"
	  }), _vm._v("健やかな育成に寄与する"), _c('br', {
	    staticClass: "hidden-sm"
	  }), _vm._v("事を目的に、"), _c('br', {
	    staticClass: "visible-sm"
	  }), _vm._v("地域とも連携し設立いたしました。")])]), _vm._v(" "), _c('p', [_c('img', {
	    staticClass: "alignLeft",
	    attrs: {
	      "src": __webpack_require__(366),
	      "alt": ""
	    }
	  }), _vm._v("私たち一般社団法人おやこハグネットは平成２２年３月に、児童の心身ともに健やかな育成に寄与する事を目的に、地域とも連携し設立いたしました。"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n      放課後児童クラブでは、“就労中の保護者が子どもさんを、安心して預けられる場所作り”“子どもたちが、安全に安定して過ごせる居心地の良い空間づくり”を目的とし運営しています。"), _c('br'), _vm._v("\n      また人と人のコミュニケーションを大切にし、保護者、学校、地域の方々と連携して子どもたちの健全な育成を行っております。"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n      児童家庭支援事業では、山代温泉まちづくり推進協議会と連携し、児童の学習支援をはじめ、今現在地域にある子ども達や子育て家庭が抱える問題を、様々な機関の方々と話し合い、ニーズに対応した支援が出来るよう取り組んでいます。")]), _vm._v(" "), _c('p', {
	    staticClass: "sign"
	  }, [_c('small', [_vm._v("一般社団法人おやこハグネット")])])])])])
	}]}

/***/ },

/***/ 388:
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "section"
	  }, [_c('div', {
	    staticClass: "Slide"
	  }, [_c('section', [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('header', [_c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(359),
	      "alt": "放課後児童クラブ"
	    }
	  })]), _vm._v(" "), _c('h2', [_vm._v("子どもたちが安心して"), _c('br', {
	    staticClass: "visible-sp"
	  }), _vm._v("安全に安定して過ごせる場所作り")])]), _vm._v(" "), _c('div', {
	    staticClass: "Main"
	  }, [_c('div', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(360),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('p', [_c('span', [_vm._v("育成目標")]), _c('br'), _vm._v("\n              「子どもたちが安心して安全に安定して過ごせる場所作り」"), _c('br'), _vm._v("\n              〇昼間の兄弟姉妹としてそれぞれの気持ちに寄り添い、優しい気持ちを持ちます。"), _c('br'), _vm._v("\n              〇正しい言葉で話します。（言葉で相手を傷つけない）"), _c('br'), _vm._v("\n              〇生活や遊びのルールを守ります。（人に迷惑をかけない）"), _c('br'), _vm._v("\n              〇自分の役割を果たします。（責任をもって行動する）\n            ")])]), _vm._v(" "), _c('p', {
	    staticClass: "note"
	  }, [_vm._v("少子化が進む昨今、家庭では経験出来ない異年齢集団の生活の中で、お互いの個性を認め合いながら、年齢に即した様々な活動を行っています。"), _c('br'), _vm._v("\n          その中で子ども達各々の成長段階を見極めながら、心の成長と社会性の育ちを見守っています。")])])]), _vm._v(" "), _c('div', {
	    staticClass: "footerContent"
	  }, [_c('ul', [_c('li', [_c('section', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(361),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v("第1代っチ")]), _vm._v(" "), _c('p', [_vm._v("住所：石川県加賀市山代温泉山背台2-44-1(山代小学校内)"), _c('br'), _vm._v("\n              TEL・FAX：0761－76－4601")])])]), _vm._v(" "), _c('li', [_c('section', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(362),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v("第2代っチ")]), _vm._v(" "), _c('p', [_vm._v("住所：石川県加賀市山代温泉山背台2-44-1(山代小学校内)"), _c('br'), _vm._v("\n                TEL・FAX：0761－76－4601")])])]), _vm._v(" "), _c('li', [_c('section', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(363),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v("第3代っチ")]), _vm._v(" "), _c('p', [_vm._v("住所：石川県加賀市山代温泉北部1-233"), _c('br'), _vm._v("\n                TEL・FAX：0761-76-1126")])])]), _vm._v(" "), _c('li', [_c('section', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(364),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v("丘の子学童")]), _vm._v(" "), _c('p', [_vm._v("住所：石川県加賀市下河崎町79-2"), _c('br'), _vm._v("\n                TEL・FAX：0761-72-2204")])])])])])])])])
	}]}

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.d4b73e888a29ba21ebd5.js